import React, { useState, useEffect } from "react";
import {
  ArrowLeft,
  PlusCircle,
  Eye,
  Edit,
  Edit2,
  Trash2,
  Upload,
} from "react-feather";
import { Link } from "react-router-dom";
import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import { useForm, FormProvider } from "react-hook-form";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { all_routes } from "Router/all_routes";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { yupResolver } from "@hookform/resolvers/yup";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { message, Popconfirm, Switch } from "antd";
import {
  useDeleteProjectMutation,
  useGetProjectsQuery,
} from "AppQuries/project/project";
import { toast } from "core/Operations/toast";
import useTableExport from "core/Operations/useTableExport";
import ReportTools from "Components/UI/ReportTools";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";

const Project = () => {
  const userData = useSelector(loggedInUser);
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const [isMount, setIsMount] = useState(false);
  const {
    data: ItemData,
    isLoading,
    isError,
    error,
    refetch: GetItems,
  } = useGetProjectsQuery(
    {
      companyCode: userData?.companyCode,
      locationCode: userData.selectedLocationCode,
      userId: userData?.userID,
    isAllCompanies: userData?.isAllCompanies,
    selectedCompanyCode: userData?.selectedCompanyCode,
      isTrue: showActiveOnly,
    },
    {
      enabled: userData?.companyCode,
    }
  );

  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const { mutate: deleteItem, isPending: isDeleting } =
    useDeleteProjectMutation();

  const deleteItemHandler = (id) => {
    const payload = {
      companyCode: userData?.companyCode,
      code: id,
    };
    console.log(payload);
    deleteItem(payload, {
      onSuccess: (data) => {
        console.log(data);
        if (data) {
          toast.success("Item Deleted Successfully");
          GetItems();
        } else {
          toast.danger(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.danger(error.message || "Something went wrong.");
      },
    });
  };

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    // {
    //   title: "S.No",
    //   dataIndex: "id",
    //   sorter: (a, b) => a.id.length - b.id.length,
    //   render: (text, record) => <>{text}</>,
    // },
    // {
    //   title: "Project Code",
    //   dataIndex: "projectCode",
    //   sorter: (a, b) => a.projectCode.length - b.projectCode.length,
    // },
    {
      title: "Project Name",
      dataIndex: "projectName",
      sorter: (a, b) => a.projectName.length - b.projectName.length,
    },
    {
      title: "Project Start Date",
      dataIndex: "projectStartDay",
      sorter: (a, b) => a.projectStartDay.length - b.projectStartDay.length,
      render: (text, record) => format(new Date(text), "dd-MM-yyyy"),
    },
    {
      title: "Project End Date",
      dataIndex: "projectEndDay",
      sorter: (a, b) => a.projectEndDay.length - b.projectEndDay.length,
      render: (text, record) => text && format(new Date(text), "dd-MM-yyyy"),
    },
    {
      title: "ProjectS tatus",
      dataIndex: "projectStatus",
      sorter: (a, b) => a.projectStatus.length - b.projectStatus.length,
    },
    {
      title: "Approved By",
      dataIndex: "approvedBy",
      sorter: (a, b) => a.approvedBy.length - b.approvedBy.length,
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      sorter: (a, b) => a.remarks.length - b.remarks.length,
    },
    {
      title: "Status",
      dataIndex: "isActive",
      render: (text, record) => (
        <>
          {text === true && (
            <div className="badge rounded-pill bg-outline-success">Active</div>
          )}
          {text === false && (
            <div className="badge rounded-pill bg-outline-danger">
              In Active
            </div>
          )}
        </>
      ),
    },

    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Can accessModule={accessCodes.project_management} accessCode={accessCodes.project_portfolio} accessType="haveEdit">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Edit</Tooltip>}
            >
              <Link
                className="me-2 p-2"
                to={`${all_routes.project}${all_routes.project_list}${all_routes.edit_project}/${record.projectCode}`}
              >
                <Edit className="feather-edit" />
              </Link>
            </OverlayTrigger>
          </Can>
          <Can accessModule={accessCodes.project_management} accessCode={accessCodes.project_portfolio} accessType="haveDelete">
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="add-new-tooltip">Delete</Tooltip>}
          >
            <Link className="me-2 p-2" to="#">
              <Popconfirm
                title="Are you sure to Delete?"
                onConfirm={() => deleteItemHandler(record.projectCode)}
              >
                <Trash2 className="feather-delete" />
              </Popconfirm>
            </Link>
          </OverlayTrigger>
          </Can>
        </div>
      ),
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    ItemData,
    searchColumns
  );

  useEffect(() => {
    if (isMount) GetItems();

    setIsMount(true);
  }, [showActiveOnly]);

  // const { onJobExcelDownload } = useTableExport({
  //   columns:
  //     Object.keys(ItemData?.[0])?.map((key) => ({
  //       title: key,
  //       dataIndex: key,
  //     })) || [],
  //   data: filteredData,
  //   fileName: "Project Details",
  //   pdfTheme: "",
  // });

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Project</h4>
                <h6>Manage Project Details</h6>
              </div>
            </div>
            <div className="page-btn">
              <ReportTools
                columns={columns}
                data={filteredData}
                fileName={`Project Details`}
                pdfTheme="plain"
                refresh={GetItems}
              />
            </div>
            <div className="page-btn" style={{ display: "flex" }}>
              <Can accessModule={accessCodes.project_management} accessCode={accessCodes.project_portfolio} accessType="haveAdd">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="add-new-tooltip">Add New Project</Tooltip>
                }
              >
                <Link
                  to={`${all_routes.project}${all_routes.project_list}${all_routes.add_project}`}
                  className="btn btn-added"
                >
                  <PlusCircle className="me-2" />
                  Add
                </Link>
              </OverlayTrigger>
              </Can>
            </div>
          </div>

          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
                showToggle={true}
              />
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                // style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="form-row row">
                    <div className="row">
                      <div className="col-lg-3 col-sm-6 col-12 mb-3">
                        <div className="form-group">
                          <Switch
                            checked={showActiveOnly}
                            checkedChildren="Show Active"
                            unCheckedChildren="Show All"
                            onChange={(checked) => setShowActiveOnly(checked)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <Table
                  className="table  datanew"
                  columns={columns}
                  dataSource={filteredData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Project;
